import { Box, Flex, Stack, Text, useColorModeValue } from "@chakra-ui/react";
import Brand from "components/sidebar/components/Brand";
import Links from "components/sidebar/components/Links";
import React from "react";

function SidebarContent(props) {
  const { routes } = props;

  const contentBg = useColorModeValue("rgba(255, 255, 255, 0.6)", "rgba(30, 41, 59, 0.6)");
  const contentBorder = useColorModeValue("rgba(0, 0, 0, 0.06)", "rgba(255, 255, 255, 0.06)");


  //  for ai powered meeting
  const updatedRoutes = routes.map((route) => {
    if (route.name === "AI Powered Meeting") {
      return {
        ...route,
        onClick: () => {
          const token = localStorage.getItem("token");
          if (!token) return;

          const encodedToken = encodeURIComponent(token);
          window.open(
            // `${process.env.REACT_APP_PUBLIC_PORTAL_FRONTEND_URL}?token=${encodedToken}`,
            `${process.env.REACT_APP_PUBLIC_PORTAL_FRONTEND_URL}/landing-page?token=${encodedToken}`,

            "_blank",
            "noopener,noreferrer"
          );
        },
      };
    }
    return route;
  });



  return (
    <Flex
      direction='column'
      height='100%'
      pt='20px'
      pb="20px"
      position="relative"
    >
      <Box px="16px">
        <Brand />
      </Box>

      <Stack direction='column' mb='auto' mt='20px' flex="1" overflowY="auto">
        <Box
          ps='16px'
          pe='16px'
        >
          <Box
            bg={contentBg}
            borderRadius="xl"
            p="3"
            border="1px solid"
            borderColor={contentBorder}
            backdropFilter="blur(10px)"
          >
            {/* <Links routes={routes} /> */}
            <Links routes={updatedRoutes} />

          </Box>
        </Box>
      </Stack>

      {/* Footer Section */}
      <Box
        px="16px"
        pt="20px"
        borderTop="1px solid"
        borderColor={useColorModeValue("gray.200", "gray.700")}
      >
        <Flex
          align="center"
          justify="space-between"
          fontSize="xs"
          color={useColorModeValue("gray.600", "gray.400")}
        >
          <Text>© {new Date().getFullYear()} Gov Portal</Text>
          <Flex align="center" gap="1">
            <Box w="2" h="2" borderRadius="full" bg="green.500" />
            <Text>Secure</Text>
          </Flex>
        </Flex>
      </Box>
    </Flex>
  );
}

export default SidebarContent;